import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDetailsContainer = (props: PropsWithChildren) => {
  const { match } = useResponsive();
  const containerStyles = [
    styles.container,
    match([styles.containerXS, styles.containerSM, styles.containerLG]),
  ];

  return (
    <SafeAreaView edges={['bottom']} style={containerStyles}>
      {props.children}
    </SafeAreaView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    rowGap: theme.spacing['4'],
    marginBottom: theme.spacing['2'],
    paddingBottom: theme.spacing['20'],
  },
  containerXS: {
    paddingHorizontal: theme.spacing['4'],
  },
  containerSM: {
    paddingHorizontal: theme.spacing['6'],
  },
  containerLG: {
    paddingHorizontal: theme.spacing['10'],
  },
});
